import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import Input from '../../components/forms/Input';
import { Field, Form, Formik, FormikProps } from 'formik';
import AuthorsService from '@/common/API/AuthorsService';
import FormFactory from '@/components/FormFactory';
import { Button } from '@/components/ui/button';
import BooksService from '@/common/API/BooksService';
import Select from '@/components/forms/Select';
import { genresList } from '@/common/static/genresList';
import FileUpload from '@/components/forms/FileUpload';
import { FormUtils } from '@/common/FormUtils';
import { useData } from '@/common/hooks/useData';
import ScrollableContainer from '@/components/ScrollableContainer';
import Screen from '@/components/layout/Screen';

const BooksAddScreen = () => {
  const formRef: MutableRefObject<any> = useRef();
  const { authors } = useData();
  const { fetchBooks } = useData();

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Add book',
          backBtnLabel: 'Books',
          backBtnUrl: '/books',
          titleClassName: 'text-white',
        },
      }}
      className='px-4 grid grid-rows-5'
    >
      <FormFactory
        className='row-span-4'
        formRef={formRef}
        initialValues={{ name: '', genre: '', author_id: '', image: '' }}
      >
        <Field
          name='image'
          uploadContainerClass=' my-3'
          containerClassName='w-1/3 mx-auto'
          placeholder='Image'
          component={FileUpload}
        />
        <Field className='mb-4 ' name='name' placeholder='Book name' component={Input} />
        <Field className='mb-4 ' name='genre' options={genresList} placeholder='Select genre' component={Select} />
        <Field className='mb-4 ' name='author_id' options={authors} placeholder='Select author' component={Select} />
      </FormFactory>
      <div className='flex items-end'>
        <Button
          onClick={() => {
            const fd = FormUtils.generateFormData(formRef.current.values, ['image']);
            BooksService.create(fd).then((res) => {
              fetchBooks();
            });
          }}
          className='w-full mt-4'
        >
          Submit
        </Button>
      </div>
    </Screen>
  );
};

export default BooksAddScreen;
